import { useMemo } from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

const pickLanding = (role) => {
    const r = (Array.isArray(role) ? role[0] : role) || null;
    if (r === 'admin') return '/user';
    if (r === 'expert') return '/task-manager'; // vagy amit szeretnél “fő” expert landingnek
    return '/what-if'; // operator default
};

export default function RoleRedirect() {
    const role = useSelector(s => s.auth?.user?.role);
    const to = useMemo(() => pickLanding(role), [role]);
    return <Redirect to={to} />;
}